import React, { FC } from 'react';
import {
  Box,
  createStyles,
  Grid,
  makeStyles,
  Theme,
  Typography,
} from '@material-ui/core';
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter';
import Agencies from '../Agencies';
import CustomDetailItem from '../../../common/components/CustomDetailItem/CustomDetailItem';
import { IBusiness } from '../utils/utils';
import { BLACK_COLOR } from '../../../constants/colors';
import BusinessEditAPA from './BusinessEditAPA';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      backgroundColor: theme.palette.background.paper,
      outline: 'none',
    },
    avatar: {
      height: 80,
      width: 80,
      marginBottom: 10,
      alignSelf: 'center',
    },
    userNameContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginBottom: 10,
    },
    userName: {
      textAlign: 'center',
      color: BLACK_COLOR,
      fontSize: 20,
      fontWeight: 'bold',
      marginLeft: 5,
    },
    apaAgency: {
      overflow: 'auto',
      paddingLeft: theme.spacing(2),
      borderLeft: `1px solid ${theme.palette.divider}`,
    },
    leftInfo: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
    rightInfo: {
      borderLeft: `1px solid ${theme.palette.divider}`,
      marginLeft: theme.spacing(1.5),
      paddingLeft: theme.spacing(1.5),
    },
  }),
);

interface Params {
  fullName: string;
  createdAt: string;
  mandataryName: string | null;
  apaName: string | null;
  apaEnseigneName?: string | null;
  status: string | null;
  agencies?: string[];
  businessState?: IBusiness;
  setBusinessState?: React.Dispatch<React.SetStateAction<IBusiness>>;
  CRMStatus?: string | null;
}

const BusinessDetailHeader: FC<Params> = (props) => {
  const {
    fullName,
    createdAt,
    mandataryName,
    apaName,
    status,
    agencies,
    businessState,
    setBusinessState,
    CRMStatus,
  } = props;
  const classes = useStyles();

  return (
    <Box className={classes.paper}>
      <BusinessCenterIcon className={classes.avatar} />
      <Box className={classes.userNameContainer}>
        <Typography>Affaire : </Typography>
        <Typography className={classes.userName}>{fullName}</Typography>
      </Box>
      <Grid container justify="center" spacing={2}>
        <Grid item xs={12} sm="auto">
          <Typography>Mandataire expert : {mandataryName}</Typography>
          <BusinessEditAPA />
          {agencies?.length ? (
            <Agencies className={classes.apaAgency} agencies={agencies} />
          ) : null}
          <Typography>Statut CRM : {CRMStatus}</Typography>
          <Typography>Statut Appli : {status}</Typography>
        </Grid>

        <Grid item xs={12} sm="auto">
          <CustomDetailItem name="Création" value={createdAt} />

          <CustomDetailItem name="idCC" value={businessState?.id?.toString()} />

          <CustomDetailItem<IBusiness>
            mutationVariableName="idCRM"
            setState={setBusinessState}
            name="idCRM"
            value={businessState?.idCRM?.toString()}
            editable={true}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default BusinessDetailHeader;
